import createProps from '@kissui/helpers/src/props.helpers'

class Intensity extends HTMLElement {
    constructor() {
        super()
        this.props = {}
    }

    connectedCallback() {
        this.props = createProps(this.attributes)
        this.render()
    }

    render() {
        const { intensity_label = 'Intensity', a11y_intensity_max, max_intensity } = this.props
        const intensity = parseInt(this.props.intensity)

        if (!intensity || isNaN(intensity)) {
            return ''
        }

        const a11yIntensityMax = a11y_intensity_max?.replace('{max_intensity}', max_intensity)

        this.innerHTML = `
            <p>
                <span class="sr-only">${intensity_label} ${intensity} ${a11yIntensityMax}</span>
                <div class="t-xs-500-sl" aria-hidden="true">${intensity_label}</div>
                ${this.renderIntensityMin(intensity)}
                <div class="t-xs-700-sl" aria-hidden="true">${intensity}</div>
                ${this.renderIntensityMax(intensity)}
            </p>
        `
    }

    renderIntensityMin(intensity) {
        const min_intensity = 0

        return new Array(Math.max(intensity, 0) - min_intensity)
            .fill('<span class="bar filled"></span>')
            .join('')
    }

    renderIntensityMax(intensity) {
        let { max_intensity } = this.props
        if (!max_intensity || max_intensity === 'undefined') {
            max_intensity = 14
        }

        return new Array(parseInt(max_intensity) - Math.min(intensity, parseInt(max_intensity)))
            .fill('<span class="bar"></span>')
            .join('')
    }
}

customElements.get('nb-intensity') || customElements.define('nb-intensity', Intensity)

export default Intensity
